import { useEffect } from "react";

const SITE_URL = process.env.REACT_APP_SITE_URL;

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (SITE_URL) {
      const url = `${SITE_URL.replace(/\/$/, "")}${path}`;
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = url;
      setMeta("property", "og:url", url);
      const img = `${SITE_URL.replace(/\/$/, "")}/og-cazares-junk-removal-greenville-sc.jpg`;
      setMeta("property", "og:image", img);
      setMeta("property", "og:image:width", "1200");
      setMeta("property", "og:image:height", "630");
      setMeta("property", "og:image:alt", "Cazares Junk Removal trailer loaded with brick in Greenville SC");
      setMeta("name", "twitter:card", "summary_large_image");
      setMeta("name", "twitter:image", img);
    }
  }, [title, description, path]);
  return null;
};
